// Angular
import { Pipe, PipeTransform } from '@angular/core';

// Data Contracts
import { PersonName } from '@data-contracts';

/**
 * A pipe that takes a PersonName object and returns the name as set in fullName, or 
 * as a combination of firstName and lastName or null if neither are set.
 */
@Pipe({
  name: 'personName',
  standalone: true
})
export class PersonNamePipe implements PipeTransform {
  /**
   * Transforms a PersonName object into a string.
   * 
   * @param personName The PersonName object to transform.
   * 
   * @returns A string representation of the PersonName object.
   */
  transform(personName: PersonName): string | null {
    // If the personName is null or undefined, return null.
    if (!personName) { return null; }

    // If the fullName property is set, return it.
    if (personName.fullName) {
      return personName.fullName;
    }

    // If the firstName and lastName properties are set, return them.
    if (personName.firstName && personName.lastName) {
      return `${personName.firstName} ${personName.lastName}`;
    }

    // If only the firstName is set and lastName is not, return the firstName. 
    if (personName.firstName && !personName.lastName) {
      return personName.firstName;
    }

    // If only the lastName is set and firstName is not, return the lastName.
    if (!personName.firstName && personName.lastName) {
      return personName.lastName;
    }

    // Otherwise, return null.
    return null;
  }
}
